import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import DraggableDialogPaper from "./DraggableDialogPaper";

function AddBedroomDialog({
  open,
  onClose,
  campuses = [],
  selectedCampus = "",
  selectedHouse = "",
  onSave,
}) {
  const [bedroomName, setBedroomName] = useState("");
  const [campus, setCampus] = useState(selectedCampus || "");
  const [capacity, setCapacity] = useState("");
  const [notes, setNotes] = useState("");
  const [house, setHouse] = useState("");
  const [ensuite, setEnsuite] = useState(false);

  useEffect(() => {
    if (open) {
      setBedroomName("");
      setCampus(selectedCampus || "");
      setHouse(selectedHouse || "");
      setCapacity("");
      setNotes("");
      setEnsuite(false);
    }
  }, [open, selectedCampus, selectedHouse]);

  const handleSave = async () => {
    const trimmedName = String(bedroomName || "").trim();
    const trimmedCampus = String(campus || "").trim();
    const parsedCapacity = Number(capacity);

    if (!trimmedName || !trimmedCampus || !parsedCapacity) {
      return;
    }

    await onSave({
      bedroomName: trimmedName,
      campus: trimmedCampus,
      capacity: parsedCapacity,
      notes: String(notes || "").trim(),
      house: String(house || "").trim(),
      ensuite,
    });
  };

  const canSave =
    String(bedroomName || "").trim() &&
    String(campus || "").trim() &&
    Number(capacity) > 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperComponent={DraggableDialogPaper}
    >
      <DialogTitle id="draggable-dialog-title" sx={{ cursor: "move" }}>Create Bedroom</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Bedroom Name"
            value={bedroomName}
            onChange={(e) => setBedroomName(e.target.value)}
            fullWidth
            required
          />

          <TextField
            select
            label="Campus"
            value={campus}
            onChange={(e) => setCampus(e.target.value)}
            fullWidth
            required
          >
            {campuses.map((c) => (
              <MenuItem key={c.id} value={c.name}>
                {c.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="House"
            value={house}
            onChange={(e) => setHouse(e.target.value)}
            fullWidth
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={ensuite}
                onChange={(e) => setEnsuite(e.target.checked)}
              />
            }
            label="Ensuite"
          />

          <TextField
            label="Capacity"
            type="number"
            value={capacity}
            onChange={(e) => setCapacity(e.target.value)}
            fullWidth
            required
            inputProps={{ min: 1 }}
          />

          <TextField
            label="Notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            fullWidth
            multiline
            minRows={2}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={!canSave}>
          Create Bedroom
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddBedroomDialog;